import styled, { css } from 'styled-components';
import { black, grey200, grey500 } from 'styles/colors';
import { ApSelect, colors } from '@alixpartners/ui-components';
import React from 'react';

export const MetadataSummaryLine = styled.tr``;

export const MetadataSummary = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 14px;
	line-height: 30px;
	width: 120px;
	font-weight: normal;
	padding: 10px 64px 10px 10px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 14px;
	font-weight: 500;
	line-height: 30px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 250px;
	margin-bottom: 19px;
	padding-right: 32px;
	> div {
		width: 300px;
		> div {
			> input {
				font-size: 12px;
			}
		}
	}
`;

export const Line = styled.hr`
	margin: 1% 0 2% 0;
	border: 0;
	height: 1px;
	background-color: ${colors.grey300};
`;

export const SelectWrapper = styled.div`
	label {
		display: none;
	}
	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 100px !important;
	${({ small }) =>
		small &&
		css`
			max-width: 100px !important;
			min-width: 100px !important;
		`};
`;

export const EditActions = styled.div`
	width: 100%;
	display: flex;
	padding: 3%;
	justify-content: space-between;
`;
export const TableHeading = styled.div`
	display: flex;
`;

export const HeadingCell = styled.div`
	margin-right: 50px;
	font-size: 14px;
`;

export const ContentDiv = styled.div`
	display: flex;
	flex-direction: column;
	height: 90%;
	justify-content: space-between;
	border-top: 2px solid ${grey200};
`;
export const TableWrapper = styled.div`
	overflow: auto;
	height: 85%;
	padding: 10px 0 0 5px;
`;
